// Centralized asset URLs (logos provided by the brand owner)
export const LOGO_SQUARE =
  "https://customer-assets.emergentagent.com/job_6b26c5e5-50fd-4198-a62e-d0e4b0706604/artifacts/3kj7zcf0_AnyUnlock%20-%20iPhone%20Password%20Unlocker.png";

export const LOGO_HORIZONTAL =
  "https://customer-assets.emergentagent.com/job_6b26c5e5-50fd-4198-a62e-d0e4b0706604/artifacts/4g2tdzcy_%D8%A7%D9%81%D9%82%D9%8A%20%D8%A7%D8%B2%D8%B1%D9%82.png";

export const LOGO_VERTICAL =
  "https://customer-assets.emergentagent.com/job_6b26c5e5-50fd-4198-a62e-d0e4b0706604/artifacts/njxf1yy3_%D8%B9%D8%A7%D9%85%D9%88%D8%AF%D9%8A%20%D8%A7%D8%B2%D8%B1%D9%82.png";

// Real Akwaan Express fleet photos provided by the user
export const FLEET_DEPOT =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/2c815yw1_2%20Adobe%20PS.png"; // truck + van + scooter at depot

export const VAN_BAGHDAD_SUNNY =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/b7ppflww_1.png"; // van in central Baghdad sunny day

export const VAN_BAGHDAD_RAIN =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/ccdwqqa5_2.png"; // van on rainy Baghdad street with reflection

// Hero rotation set
export const HERO_PHOTOS = [FLEET_DEPOT, VAN_BAGHDAD_SUNNY, VAN_BAGHDAD_RAIN];

// Akwaan brand hero logo (used as the main focal on the homepage hero)
export const HERO_LOGO =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/wostea83_Untitled%20design%20%284%29.png";

// Iraqi heritage / landscape backdrops (semi-transparent rotating behind hero)
export const IRAQ_HATRA =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/763gnto5_Untitled%20design%20%285%29.png";
export const IRAQ_BAGHDAD_HERITAGE =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/vogmzhgn_Untitled%20design%20%286%29.png";
export const IRAQ_TIGRIS =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/b0xvz5dd_Untitled%20design%20%287%29.png";
export const IRAQ_SHAHEED =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/jtlaaz7d_Untitled%20design%20%288%29.png";

export const HERITAGE_BACKDROPS = [IRAQ_HATRA, IRAQ_BAGHDAD_HERITAGE, IRAQ_TIGRIS, IRAQ_SHAHEED];

// Backwards-compat aliases used by other pages
export const HERO_IMG = FLEET_DEPOT;
export const ABOUT_IMG = VAN_BAGHDAD_SUNNY;
export const SERVICE_IMG = VAN_BAGHDAD_RAIN;

// Warehouse / logistics interior photo (used on About page)
export const WAREHOUSE_IMG =
  "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1400&q=80";

// Partner logos (provided by Akwaan Express)
export const LOGO_CIHAN_BANK =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/oo0ykxfh_B8uWuLOqpP9UDpq2c3Zk.png";
export const LOGO_QI =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/xqlrzit1_uK8Tl0Ie4VFeMmJwu8vPRnM72DhTLzjk.png";
export const LOGO_RAMASAT =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/o0ji2qzj_Screenshot%202026-04-28%20at%2019.33.49.png";
export const LOGO_ELIXR =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/2x4guxl0_WhatsApp%20Image%202026-04-28%20at%2019.36.48.jpeg";
export const LOGO_TAIF =
  "https://customer-assets.emergentagent.com/job_akwaan-express/artifacts/ovm0lhhj_logo_1.avif";

// New partner logos
export const LOGO_SUPERCELL =
  "https://customer-assets-agu9un31.emergentagent.net/job_akwaan-express/artifacts/4w19cxsc_images1.png";
export const LOGO_ASTICO =
  "https://customer-assets-agu9un31.emergentagent.net/job_akwaan-express/artifacts/k84rm09j_unnamed.png";
export const LOGO_RTB =
  "https://customer-assets-agu9un31.emergentagent.net/job_akwaan-express/artifacts/ijes7io0_WhatsApp%20Image%202026-06-18%20at%2011.52.32.jpeg";
